import { useCallback, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, IconButton, Tooltip } from '@treezor/design-system';

import { TFavorite } from '@/features/dashboard-users/store/support-user.model';

import { useMatomo } from '@/features/matomo/useMatomo';

import { FavoriteList } from './FavoriteList';

interface IFavoriteMenuProps {
  favorites: TFavorite[];
}

export function FavoriteMenu({ favorites }: IFavoriteMenuProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const ref = useRef<HTMLAnchorElement & HTMLButtonElement>(null);
  const { t } = useTranslation();
  const { triggerEvent } = useMatomo();

  const handleClick = useCallback(() => {
    if (!isMenuOpen) {
      triggerEvent('starred-wallet', {
        'starred-wallet-action': 'display',
        'starred-wallet-action-value': 0,
      });
    }
    setIsMenuOpen(!isMenuOpen);
  }, [isMenuOpen, setIsMenuOpen, triggerEvent]);

  return (
    <div className="relative">
      <Tooltip messageContent={t('pages.dashboard.favorites.favorites')} placement="bottom" contentClassName="z-[101]">
        <IconButton ref={ref} icon="star" onClick={handleClick} />
      </Tooltip>

      {isMenuOpen && (
        <Dropdown
          onClose={handleClick}
          parentRef={ref}
          className="!w-min"
          contentClassName="[&>div:first-child]:overflow-x-hidden"
        >
          <FavoriteList type="wallet" list={favorites} onClose={handleClick} />
        </Dropdown>
      )}
    </div>
  );
}
